// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__214ES","type":"styles_type__3wMu6","choices":"styles_choices__2VEG_"};